import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { Text } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import { ProfileMenu } from "../../components/ProfileMenu";
import { useQuestionnaireSummaries } from "../../hooks/useQuestionnaireSummaries";
import { useRefetchOnOverlayClose } from "../../hooks/useRefetchOnOverlayClose";
import { useSupportSurface } from "../../hooks/useSupportSurface";
import { SummaryList } from "../../summary/SummaryList";
import { SupportSteps } from "./SupportSteps";
import s from "./SupportScreen.module.css";

export function SupportScreen() {
  const { t } = useTranslation("client");
  const { state, refetch } = useSupportSurface();
  const { state: summariesState, refetch: refetchSummaries } = useQuestionnaireSummaries();
  const summaries = summariesState.status === "success" ? summariesState.summaries : [];
  const { pathname } = useLocation();
  useRefetchOnOverlayClose(refetchSummaries);

  // Same two refetches as InfusionScreen: the screener is shared with the
  // infusion tab, so it can be finished from there, and the questionnaire
  // overlay finishes it without this tab ever going inactive.
  const isActive = pathname === "/support";
  const wasActiveRef = useRef(isActive);
  useEffect(() => {
    if (isActive && !wasActiveRef.current) {
      refetch();
      refetchSummaries();
    }
    wasActiveRef.current = isActive;
  }, [isActive, refetch, refetchSummaries]);

  useRefetchOnOverlayClose(refetch);

  return (
    <>
      <div className={s.header}>
        <Text as="h1" size="xl" weight="bold" className={s.title}>
          {t("support.title", "Asiantuntijatuki")}
        </Text>
        <ProfileMenu className={s.profile} />
      </div>
      <div className={s.body}>
        {/* Coaching, not care: Mari is a nutrition coach, and nothing on this
            tab may read as a diagnosis or a treatment. */}
        <Text as="p" size="md" className={s.intro}>
          {t(
            "support.intro",
            "Ferrivian terveystiimi auttaa sinua kartoittamaan raudanpuutteen juurisyitä. Autamme sinua rautavalmisteiden, ruokavalion, elintapojen ja lisäravinteiden kanssa. Lisäksi laadimme henkilökohtaisen suunnitelman raudan imeytymisen ja suoliston hyvinvoinnin tueksi.",
          )}
        </Text>
        {state.status === "success" ? (
          <SupportSteps
            steps={state.surface.steps}
            summaries={summaries}
            refetch={refetch}
            assessmentPaid={state.surface.assessmentPaid}
          />
        ) : null}
        <SummaryList summaries={summaries} path="support" />
      </div>
    </>
  );
}
